import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import posthog from 'posthog-js'

// PostHog is enabled in non-dev environments, or when VITE_ENABLE_POSTHOG=true in .env.local
const isPostHogEnabled =
  import.meta.env.MODE !== 'development' ||
  import.meta.env.VITE_ENABLE_POSTHOG === 'true'

/**
 * Hook to capture pageviews on route changes for PostHog analytics.
 * Should be used once at the top level inside a RouterProvider.
 *
 * - $current_url: Clean URL without query params (for grouping in dashboards)
 * - full_url: Complete URL with query params (for detailed analysis)
 * - Only triggers on pathname changes, not query param changes
 */
export function usePostHogPageview() {
  const location = useLocation()

  useEffect(() => {
    if (!isPostHogEnabled) {
      return
    }

    posthog.capture('$pageview', {
      // Clean URL for dashboard grouping
      $current_url: `${window.location.origin}${location.pathname}`,
      // Full URL with query params for detailed analysis
      full_url: window.location.href,
    })
  }, [location.pathname]) // Only trigger on pathname changes, not query params
}

/**
 * Component wrapper for usePostHogPageview.
 * Use this inside a RouterProvider to track all pageviews.
 */
export function PostHogPageviewTracker() {
  usePostHogPageview()
  return null
}
